// extracted by mini-css-extract-plugin
export var general = "CarouselArrowStyles-module--general---Kh6L";
export var line = "CarouselArrowStyles-module--line--IV854";
export var polyline = "CarouselArrowStyles-module--polyline--XKyNN";
export var primary = "CarouselArrowStyles-module--primary--aXktb";
export var primaryviolet = "CarouselArrowStyles-module--primaryviolet--gIg1a";
export var rect = "CarouselArrowStyles-module--rect--NPV-+";
export var secondary = "CarouselArrowStyles-module--secondary--4Kvf2";
export var transparentBackground = "CarouselArrowStyles-module--transparent-background--Kxb7n";